import { Action, SubjectRoles } from "@/api-schema-enums";
import { AppAbility } from "@/casl-provider";
import { User } from "@/store/user-store";
import { AbilityBuilder } from "@casl/ability";

export const VEHICLE_VALUATION_SNAPSHOT_SUBJECT = "VehicleValuationSnapshot" as const;

export function setVehicleValuationPermissions(user: User, builder: AbilityBuilder<AppAbility>) {
  const { can } = builder;

  if (user.roles.includes(SubjectRoles.FabVehicleValuationAdministrator)) {
    can(Action.Read, "VehicleValuation");
    can(Action.Read, VEHICLE_VALUATION_SNAPSHOT_SUBJECT);
  }
  if (user.roles.includes(SubjectRoles.FabVehicleValuationApprover)) {
    can(Action.Read, "VehicleValuation");
    can(Action.Manage, "VehicleValuation");
  }
  if (user.roles.includes(SubjectRoles.FabVehicleValuationUser)) {
    can(Action.Read, "VehicleValuation");
    can(Action.Create, "VehicleValuation");
  }
}
